var _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 47,
    viewBox: "0 0 53 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5651 40.9316C34.4753 35.6219 36.3641 29.1755 36.4391 28.9039L36.5 28.6849V13.4602L23.5 8.5L10.5 13.4602V28.6849L10.5609 28.9039C10.6359 29.1755 12.5267 35.6219 22.4349 40.9316L23.5 41.5L24.5651 40.9316Z",
    fill: "#379335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 46.9C23.9971 46.9 24.4 46.4971 24.4 46C24.4 45.503 23.9971 45.1 23.5 45.1V46.9ZM7.59011 7.59011L8.2265 8.2265L7.59011 7.59011ZM19.1105 1.43234L19.2861 2.31505L19.1105 1.43234ZM32.1104 2.71272L31.766 3.54421L32.1104 2.71272ZM45.3636 24.1364C45.7151 24.4879 46.2849 24.4879 46.6364 24.1364L52.364 18.4088C52.7154 18.0574 52.7154 17.4875 52.364 17.136C52.0125 16.7846 51.4427 16.7846 51.0912 17.136L46 22.2272L40.9088 17.136C40.5574 16.7846 39.9875 16.7846 39.6361 17.136C39.2846 17.4875 39.2846 18.0574 39.6361 18.4088L45.3636 24.1364ZM23.5 45.1C19.2279 45.1 15.0518 43.8332 11.4997 41.4598L10.4997 42.9564C14.3478 45.5276 18.8719 46.9 23.5 46.9V45.1ZM11.4997 41.4598C7.94759 39.0863 5.17907 35.7129 3.54421 31.766L1.88123 32.4548C3.65232 36.7306 6.65156 40.3852 10.4997 42.9564L11.4997 41.4598ZM3.54421 31.766C1.90936 27.8191 1.48161 23.476 2.31505 19.2861L0.549635 18.9349C-0.35326 23.4741 0.110139 28.179 1.88123 32.4548L3.54421 31.766ZM2.31505 19.2861C3.14849 15.0961 5.20569 11.2473 8.2265 8.2265L6.95371 6.95371C3.68116 10.2263 1.45253 14.3957 0.549635 18.9349L2.31505 19.2861ZM8.2265 8.2265C11.2473 5.20569 15.0961 3.14849 19.2861 2.31505L18.9349 0.549635C14.3957 1.45253 10.2263 3.68116 6.95371 6.95371L8.2265 8.2265ZM19.2861 2.31505C23.476 1.48161 27.8191 1.90936 31.766 3.54421L32.4548 1.88123C28.179 0.110138 23.4741 -0.35326 18.9349 0.549635L19.2861 2.31505ZM31.766 3.54421C35.7129 5.17907 39.0863 7.94759 41.4598 11.4997L42.9564 10.4997C40.3852 6.65156 36.7306 3.65232 32.4548 1.88123L31.766 3.54421ZM41.4598 11.4997C43.8332 15.0518 45.1 19.2279 45.1 23.5H46.9C46.9 18.8719 45.5276 14.3478 42.9564 10.4997L41.4598 11.4997Z",
    fill: "black",
    fillOpacity: 0.47
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 22.502,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(-39.6904 15 22.502)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1055,
    y: 31.0624,
    width: 4,
    height: 15,
    rx: 2,
    transform: "rotate(-129.69 22.1055 31.0624)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6);
export default __webpack_public_path__ + "static/media/Group 6.3ab98637d9a0180d877d804a4989d941.svg";
export { ForwardRef as ReactComponent };